export default `

正常响应

\`\`\`json
{
    "code": 0,
    "status": 200,
    "message": "success",
    "data": {
        // 具体 API 响应数据
    }
}
\`\`\`

错误响应

\`\`\`json
{
    "code": 具体错误码，详细信息请参考错误码表,
    "status": 具体错误类型 HTTP Status Code,
    "message": "具体错误描述",
    "data": {}
}
\`\`\`

## 接口示例

**API: \`com.souche.shield.service#getUserById\`（根据用户 ID 获取用户信息）**

### 请求参数文档

| 字段 | 类型   | 是否必须 | 含义    |
| ---- | ------ | -------- | ------- |
| id   | String | ✔️        | 用户 ID |


### 请求地址：http://openapi.proxy.dasouche.com/v3

### 请求参数

\`\`\`json
{
      "api": "com.souche.shield.service#getUserById",
      "appKey": "ad33d1190ff8383b5650097c0b6403868a82bd4c",
      "timestamp": 1528420183,
      "data": "{\\"id\\":\\"xv1fg4h\\"}",
      "sign": "9b94171630348afdb950b8c26edeec608e0c1f78"
}
\`\`\`

### 响应数据

\`\`\`json
{
      "code": 0,
      "status": 200,
      "message": "success",
      "data": {
          "name": "Tom",
          "gender": 1,
          "avatar": "http://picture.com/users/xv1fg4h"
      }
 }
\`\`\`



### 请求 curl 代码

\`\`\`sh
curl -X POST \\
    http://api.proxy.dasouche.com/v3 \\
    -H 'content-type: application/json' \\
    -d '{
      "api": "com.souche.shield.service#getUserById",
      "appKey": "ad33d1190ff8383b5650097c0b6403868a82bd4c",
      "timestamp": 1528420183,
      "data": "{\\"id\\":\\"xv1fg4h\\"}",
      "sign": "9b94171630348afdb950b8c26edeec608e0c1f78"
  }'
\`\`\``


